export default __webpack_public_path__ + "16baaf4549b35ce855011291cb7969ed.png";